<template>
  <div>
    <!-- Dialog to Create & Edit a attachments -->
    <Dialog
      :visible.sync="attachmentForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Attachment Details"
      :modal="true"
      class="p-fluid"
      v-cloak
      @drop.prevent="addFile"
      @dragover.prevent
    >
      <div class="p-formgrid p-grid" v-if="isAttachmentPresent()">
        <div class="p-field p-col-12" style="text-align: center;">
          <p>You can also drop the file in this form</p>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">File Name:</label>
          <div class="p-grid">
            <div class="p-col-12 p-lg-12">
              <div class="p-inputgroup">
                <InputText
                  v-if="attachment.attachId"
                  id="noteHeader"
                  v-model.trim="attachment.fileName"
                  required="true"
                  :disabled="true"
                  autofocus
                />
                <InputText
                  v-else
                  id="noteHeader"
                  v-model.trim="file.name"
                  required="true"
                  :disabled="true"
                  autofocus
                />
                <Button
                  :disabled="isAttachmentPresent()"
                  icon="pi pi-download"
                  @click="download"
                />
                <Button
                  :disabled="!file.name"
                  class="p-button-danger p-mx-2"
                  icon="pi pi-times"
                  @click="clearFile"
                />
                <Button
                  label="Add file"
                  class="p-button-info"
                  icon="pi pi-plus"
                  @click="clickButton"
                  iconPos="right"
                  :disabled="!isAttachmentPresent()"
                />
                <input
                  single
                  type="file"
                  id="image1"
                  style="display: none;"
                  accept="*/*"
                  @change="onFileSelect"
                  :disabled="!isAttachmentPresent()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">File Description: </label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="thisAttachment.attachDesc"
          />
        </div>
      </div>
      <template v-if="!hideQuotationVersionFields">
        <!-- <div class="p-formgrid p-grid" v-if="quotations && quotations[0]">
        <div class="p-field p-col">
          <label for="noteDetails">Quotation first if:</label>
          <Dropdown
            :showClear="true"
            v-model="thisQuotation"
            :options="quotations"
            dataKey="quoteVerId"
            optionLabel="sQuoteNo"
            placeholder="Select Customer"
          />
          <small class="p-invalid" v-if="submitted && quotations && quotations[0] && !(thisQuotation && thisQuotation.quoteVerId)"
            >Quotation is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Version No:</label>
          <InputText
            placeholder=""
            disabled="true"
            :autoResize="true"
            rows="6"
            v-model="thisQuotation.versionNo"
          />
        </div>
      </div> -->
        <!-- <div class="p-formgrid p-grid" v-else> -->
        <!--
          Here I replaceed quotation with this.Quotation as we can't mutate the prop directly in the 
          component
          -->
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="noteDetails">Quotation:</label>
            <InputText
              placeholder=""
              disabled="true"
              :autoResize="true"
              rows="6"
              v-model="thisQuotation.sQuoteNo"
            />
          </div>
          <div class="p-field p-col">
            <label for="noteDetails">Version No:</label>
            <InputText
              placeholder=""
              disabled="true"
              :autoResize="true"
              rows="6"
              v-model="thisQuotation.versionNo"
            />
          </div>
        </div>
      </template>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="attachTags">File Tags:</label>
          <MultiSelect
            v-model="thisAttachment.attachTags"
            :options="tags"
            dataKey="id"
            optionLabel="tag"
            placeholder="Select tag/s"
            display="chip"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Date Added:</label>
          <InputText
            placeholder=""
            :disabled="true"
            :autoResize="true"
            rows="6"
            v-model="thisAttachment.dateCreated"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideDialog"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveAttachment"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import AttachmentService from "@/service/AttachmentService";
import TagsService from "@/service/TagsService";

import { attachmentRequest } from "../sendRequest";

export default {
  props: [
    "quotations",
    "attachment",
    "quotation",
    "attachmentForm",
    "customer",
    "hideQuotationVersionFields"
  ],
  data: () => ({
    attachmentService: new AttachmentService(),
    tagsService: new TagsService(),
    file: {},
    thisQuotation: {},
    thisAttachment: {},
    submitted: false,
    tags: [],
    sendingRequest: false
  }),
  computed: {
    attachmentForm1: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        return this.attachmentForm === true ? true : false;
      }
    }
  },
  created() {
    if (this.attachment) {
      this.thisAttachment = this.attachment;
      if (typeof this.attachment.attachTags === "string") {
        let a = this.attachment.attachTags.split(",");
        if (!a[a.length - 1]) {
        }
        a.pop();
        this.thisAttachment.attachTags = a;
      }
    }
    // if (this.quotation) {
    //   this.thisQuotation = this.quotation
    // }
    if (this.quotations && this.quotations[0]) {
      this.thisQuotation = this.quotations[0];
      this.thisQuotation.versionNo = this.quotations.length;
    }
    this.getTagsOfType();
  },
  watch: {
    attachment(val) {
      if (val && val.attachId) {
        this.thisAttachment = val;
      }
    }
  },
  methods: {
    getTagsOfType() {
      this.tagsService
        .getTagsOfType("ATTACHMENT")
        .then(data => {
          this.tags = data;
          if (this.thisAttachment.attachTags)
            this.thisAttachment.attachTags = this.thisAttachment.attachTags.map(
              tag => data.find(t => t.tag === tag)
            );
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while geting tags for ATTACHMENT",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "tags/type"'
          });
        });
    },
    send() {
      if (this.quotations && this.quotations[0]) {
        if (this.thisQuotation && this.thisQuotation.quoteVerId) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    onFileSelect(e) {
      if (e.target.files && e.target.files[0]) {
        if (e.target.files[0].size < 10485760) {
          this.file = e.target.files[0];
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Big file",
            detail: "File size is greater than 10MB.",
            life: 5000
          });
        }
      }
    },
    clickButton() {
      document.getElementById("image1").click();
    },
    saveAttachment() {
      this.submitted = true;

      if (this.send()) {
        this.sendingRequest = true;
        attachmentRequest(this, "attachmentForm.vue");
      }
    },
    hideDialog() {
      this.$emit("close");
    },
    clearFile() {
      this.file = {};
    },
    download() {
      this.attachmentService.fileDownloader(this.thisAttachment.fileName);
    },
    isAttachmentPresent() {
      return this.attachment && this.attachment.fileName ? false : true;
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;

      let a = droppedFiles[0];
      //
      a.fileName = a.name;
      this.file = a;
    }
  }
};
</script>

<style></style>
